import { ContractType } from "./contract";

class ContractTypeHelper {

    public isCash(contractType: ContractType): boolean {
        return contractType === ContractType.Cash || contractType === ContractType.CashMinPrice;
    }

    public isHta(contractType: ContractType): boolean {
        return contractType === ContractType.Hta || contractType === ContractType.HtaMinPrice;
    }

    public isBushelOnly(contractType: ContractType): boolean {
        return contractType === ContractType.BushelOnly;
    }

    public hasBasis(contractType: ContractType): boolean {
        return [ContractType.Cash, ContractType.CashMinPrice, ContractType.Basis, ContractType.BushelOnly].includes(contractType);
    }

    public hasHtaFee(contractType: ContractType): boolean {
        return [ContractType.Hta, ContractType.Cash, ContractType.HtaMinPrice, ContractType.CashMinPrice].includes(contractType);
    }
}

const contractTypeHelper = new ContractTypeHelper()

export default contractTypeHelper;